type Props = {
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  type?: 'inverted' | 'primary' | 'toggle';
  disabled?: boolean;
  text?: string;
  isActive?: boolean;
  href?: string;
  spanClass?: string;
};

const primaryClasses = 'bg-primary text-white';
const invertedClasses = 'border-solid border border-primary  no-underline';
const toggleClasses =
  'bg-white text-primary border-solid border border-secondary hover:bg-secondary no-underline';

const activeClasses = 'bg-primary text-white';

export function Button({
  children,
  className = '',
  onClick,
  type = 'primary',
  disabled = false,
  text = '',
  isActive = false,
  href = '',
  spanClass = '',
}: Props) {
  return (
    <>
      {href.length ? (
        <a
          target="_blank"
          href={href}
          onClick={onClick}
          className={`${type === 'primary' && primaryClasses} ${
            type === 'inverted' && invertedClasses
          }
            ${type === 'toggle' && toggleClasses}
            flex items-center justify-center p-[0.625em] text-[0.75em] font-medium uppercase tracking-[0.053em] ${
              isActive && activeClasses
            }
            ${disabled && 'cursor-not-allowed opacity-50'}
            ${className} `}
          rel="noreferrer"
        >
          <span className={`${spanClass}`}>{text}</span>
          {children && children}
        </a>
      ) : (
        <button
          type="button"
          disabled={disabled}
          onClick={onClick}
          className={`${type === 'primary' && primaryClasses} ${
            type === 'inverted' && invertedClasses
          }
            ${type === 'toggle' && toggleClasses}
            flex items-center justify-center p-[0.625em] text-[0.75em] font-medium uppercase tracking-[0.053em] ${
              isActive && activeClasses
            }
            ${disabled && 'cursor-not-allowed opacity-50'}
            ${className} `}
        >
          <span> {text}</span>
          {children && children}
        </button>
      )}
    </>
  );
}
